<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="agreement?.name"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    <!-- Skeleton table while loading — rows float in with the entrance cascade;
         the real table below then replaces it in place, instantly (skipEntrance). -->
    @if (!loaded) {
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    }

    @if (loaded) {
      <tidy-card>
        <tidy-row>
          <tidy-text [header]="agreement?.name" />
        </tidy-row>
        <tidy-row>
          <tidy-text [body]="('Created: ' | translate) + agreement?.created_at" />
        </tidy-row>
        <tidy-row>
          <tidy-text [body]="('Last Modified: ' | translate) + agreement?.updated_at" />
        </tidy-row>
      </tidy-card>

      <tidy-row class="extra-bottom-padding">
        <tidy-button
          [text]="'Send for E-Signature'"
          [action]="goToSendForSignature.bind(this)"
          class="primary" />
      </tidy-row>

      <tidy-row>
        <tidy-text [title]="'Signers'" />
      </tidy-row>

      <form [formGroup]="form" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search signers'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>

      <tidy-table
        #signersTable
        [dataSource]="shownSignerRows"
        [displayedColumns]="headers"
        [columnslabels]="headers"
        [showColumnLines]="false"
        [rowsToShow]="50"
        [skipEntrance]="true"
        [blockSorting]="true" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
